/* eslint-disable import/prefer-default-export */
import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getQuestionResponses = async (surveyResponseId, page, limit) => {
  try {
    const { data } = await axios.get(`/api/question-responses/${surveyResponseId}/?page=${page}&limit=${limit}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const postSurveyTeleaudit = async (objectId, surveyId,
  productId, categoryCode, taskInstanceId, questionsResponses, objectClass) => {
  try {
    const payload = {
      surveyId,
      productId,
      categoryCode,
      taskInstanceId,
      questionsResponses,
      objectId,
      objectClass,

    };
    const { data } = await axios.post('/api/survey-response-teleaudit', payload);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getQuestionResponseImages = async ({ surveyResponseId }) => {
  try {
    const { data } = await axios.get(`/api/question-responses/${surveyResponseId}/image`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getQuestionResponseById = async ({ questionResponseId }) => {
  try {
    const { data } = await axios.get(`/api/question-responses/${questionResponseId}/question`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getSurvey = async (id) => {
  try {
    const paramId = id.id;
    const { data } = await axios.get(`/api/surveys/${paramId}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getQuestionResponseVideos = async (surveyResponseId) => {
  try {
    const { data } = await axios.get(`/api/teleaudit-survey-responses/${surveyResponseId.taskResponseId}/${surveyResponseId.questionResponseId}/videos`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const putQuestionReponseTeleauditStatus = async ({
  questionResponseId,
  teleauditStatus,
  taskResponseId,
  last,
  commentTeleaudit,
  type,
  startDate,
  finishDate,
}) => {
  try {
    const { data } = await axios.put(`/api/question-responses/${questionResponseId}`, {
      teleauditStatus,
      taskResponseId,
      last,
      commentTeleaudit,
      type,
      startDate,
      finishDate,
    });
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const getQuestionResponseDetailById = async (questionResponseId) => {
  try {
    const { data } = await axios.get(`/api/question-responses/${questionResponseId}/detail`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const putQuestionResponseData = async (
  questionResponseId, updateData,
) => {
  try {
    const isFormData = updateData instanceof FormData;
    const useBuffer = isFormData && updateData.get('useBuffer') === 'true';

    // Usar endpoint diferente para MULTIPLE_IMAGE_QUESTION
    const endpoint = useBuffer
      ? `/api/question-responses/${questionResponseId}/edit-multiple-images`
      : `/api/question-responses/${questionResponseId}/edit`;

    const payload = isFormData ? updateData : { ...updateData };
    const config = isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};

    const { data } = await axios.put(endpoint, payload, config);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

export {
  getQuestionResponses,
  getQuestionResponseImages,
  getQuestionResponseById,
  putQuestionReponseTeleauditStatus,
  getSurvey,
  postSurveyTeleaudit,
  getQuestionResponseVideos,
  getQuestionResponseDetailById,
  putQuestionResponseData,
};
